import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'

export interface OptionTranslation {
  _id?:ID
  option_id?: ID;
  language: string;
  title: string;
}


export interface Option {
  _id?: ID;
  translations: OptionTranslation[];
 

}




export const initialOption: Option = {

  translations: [
    {
 
      language: '',
      title: '',
      
    },
  ],

};
export type OptionsQueryResponse = Response<Array<Option>>;
export type QueryResponseOptionContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createOptionResponseContext<T>(initialState: QueryResponseOptionContextProps<T>) {
  return createContext(initialState)
}
export const initialOptionQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }